import { useEffect, useMemo, useRef, useState } from "react";
import styles from "./Header.module.css";
import { useDispatch, useSelector } from "react-redux";
import { selectData, setIsSticky } from "../../redux/dataSlice";
import { processHeader } from "../../utils/mapping";
import NavBar from "../NavBar";
import BannerHTMLContent from "../BannerHtmlContent";
import EnquireNow from "../EnquireNow";
import LoadingSpinner from "../../components/LoadingSpinner";

const Header = () => {
  const [loading, setLoading] = useState(true);
  const data = useSelector(selectData);
  const dispatch = useDispatch();

  const { isMobileDevice } = useSelector((state: any) => state.data);

  const processedData = processHeader(data);

  const bannerRef = useRef(null);

  const handleScroll = () => {
    const bannerHeight = bannerRef?.current?.offsetHeight;
    if (window.scrollY > bannerHeight) {
      dispatch(setIsSticky(true));
    } else {
      dispatch(setIsSticky(false));
    }
  };

  useEffect(() => {
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const bannerImage = useMemo(() => {
    if (!processedData) return null;
    return {
      backgroundImage: `url(${
        isMobileDevice ? processedData?.mobileBanner : processedData?.banner
        // processedData?.banner
      })`,
    };
  }, [processedData, isMobileDevice]);

  useEffect(() => {
    if (bannerImage) {
      setLoading(false);
    }
  }, [bannerImage]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return bannerImage ? (
    <>
      <div
        style={bannerImage}
        ref={bannerRef}
        className={`${styles.banner}`}
        data-testid="header-container-id"
      >
        <div className={`${styles.overlay}`}></div>
        <div className="container h-100">
          <div className="d-flex flex-column h-100">
            <NavBar />
            <BannerHTMLContent
              content={processedData?.title}
              className={` ${styles.descText}`}
            />

            <EnquireNow />
          </div>
        </div>
      </div>
    </>
  ) : (
    <NavBar />
  );
};

export default Header;
